"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n"])), function (p) {
  return p.alignItems || "flex-start";
});

var StyledInput = _styledComponents.default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -9999px;\n"])));

var StyledCheckbox = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 0 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 24px;\n  border-radius: 0.25rem;\n  background: ", ";\n"])), function (p) {
  return p.isChecked && p.isDisabled ? p.theme.colorDisabledBackground : p.isChecked ? p.theme.colorCheckboxActiveBackground || p.theme.colorAccent : p.theme.colorCheckboxGrey || p.theme.colorLightGrey;
});

var StyledCheckboxCheck = (0, _styledComponents.default)(_.MatIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n  opacity: ", ";\n  transition: opacity 0.25s;\n"])), function (p) {
  return p.isDisabled ? p.theme.colorDisabledText : p.theme.colorCheckboxActiveForeground || p.theme.colorAccentText;
}, function (p) {
  return p.isChecked ? 1 : 0;
});

var StyledText = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-left: 0.675rem;\n  display: inline;\n  line-height: 1.25;\n  font-weight: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.fontWeightNormal;
}, function (p) {
  return p.isSmallerText ? "0.75rem" : "0.9375rem";
}, function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.isChecked ? p.theme.colorText : p.theme.colorLabel;
});

var FormCheckbox = function FormCheckbox(_ref) {
  var alignItems = _ref.alignItems,
      checked = _ref.checked,
      name = _ref.name,
      onChange = _ref.onChange,
      label = _ref.label,
      labelLinkText = _ref.labelLinkText,
      isSmallerText = _ref.isSmallerText,
      onLabelLinkClicked = _ref.onLabelLinkClicked,
      disabled = _ref.disabled,
      style = _ref.style;

  var handleLabelLinkClicked = function handleLabelLinkClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    onLabelLinkClicked();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    alignItems: alignItems,
    style: style,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInput, {
      disabled: disabled,
      checked: checked,
      name: name,
      onChange: onChange,
      type: "checkbox"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCheckbox, {
      isDisabled: disabled,
      isChecked: checked,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCheckboxCheck, {
        isDisabled: disabled,
        isChecked: checked,
        children: "check"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledText, {
      isSmallerText: isSmallerText,
      isChecked: checked,
      isDisabled: disabled,
      children: [label, labelLinkText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.TextButton, {
        onClick: handleLabelLinkClicked,
        children: labelLinkText
      })]
    })]
  });
};

FormCheckbox.propTypes = {
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  checked: _propTypes.default.bool.isRequired
};
var _default = FormCheckbox;
exports.default = _default;